<template>
  <div class="result-screen">
    <header class="result-header">
      <v-btn icon class="result-back" @click="$emit('back')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <img src="@/assets/header.png" alt="APA" />
    </header>
    <div class="result-body">
      <div class="result-card tw-p-6 md:tw-p-10 tw-text-center">
        <v-avatar color="error" size="72">
          <v-icon color="white" size="40">mdi-exclamation</v-icon>
        </v-avatar>
        <h2 class="tw-text-xl md:tw-text-2xl tw-font-bold tw-mt-5 tw-mb-1">
          Submission didn't go through
        </h2>
        <p class="tw-text-sm c-gray-text tw-max-w-sm tw-mx-auto">
          Don't worry — <b>nothing you entered was lost</b>. This is usually a
          network hiccup. Please try again.
        </p>

        <div
          class="tw-rounded-xl tw-border tw-border-yellow-200 tw-bg-yellow-50 tw-p-4 tw-my-6 tw-text-xs md:tw-text-sm c-gray-text"
        >
          If it keeps failing, call us on <b>0709 912 777</b> or email
          <b>claims@apainsurance.org</b> and quote your policy number.
        </div>

        <v-btn
          color="primary"
          block
          x-large
          data-testid="retry"
          @click="$emit('retry')"
        >
          Try again
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailedScreen',
  emits: ['retry', 'back'],
}
</script>

<style scoped>
.result-screen {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 48px);
  background: #f7f9fc;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 34px;
}

.result-back {
  background: #f4f7fb;
}

.result-header img {
  width: 96px;
}

.result-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px 24px;
}

.result-card {
  width: 100%;
  max-width: 460px;
  border: 1px solid #e4e9f1;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 18px 44px rgba(17, 76, 172, 0.08);
}

@media (max-width: 640px) {
  .result-screen {
    min-height: 100vh;
  }

  .result-header {
    padding: 16px 20px;
  }

  .result-header img {
    width: 72px;
  }
}
</style>
